define("settings/components/section", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tAC--section" ...attributes>
    {{#if @title}}
      <h2 class="tAC--section__title u--clearfix u--flex u--flex__alignItems--center {{@titleStyles}} {{@qaClass}}">
        <span class="u--float--left">
          {{@title}}
        </span>
        {{#if @badge}}
          <span class="o--badge--sm u--m__l__xs">{{@badge}}</span>
        {{/if}}
      </h2>
      {{#if @subtitle}}
        <p class={{@subtitleStyles}}>
          {{@subtitle}}
        </p>
      {{/if}}
      {{#unless @hideDivider}}
        <hr class="tAC--section__divider" />
      {{/unless}}
    {{/if}}
    {{yield
      (hash
        wrapper=(component "section/item-wrapper")
        details=(component "section/item-details")
        action=(component "section/item-action")
      )
    }}
  </section>
  */
  {
    "id": "43yv1lp4",
    "block": "[[[11,\"section\"],[24,0,\"tAC--section\"],[17,1],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,\"h2\"],[15,0,[29,[\"tAC--section__title u--clearfix u--flex u--flex__alignItems--center \",[30,3],\" \",[30,4]]]],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--float--left\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,5],[[[1,\"        \"],[10,1],[14,0,\"o--badge--sm u--m__l__xs\"],[12],[1,[30,5]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[41,[30,6],[[[1,\"      \"],[10,2],[15,0,[30,7]],[12],[1,\"\\n        \"],[1,[30,6]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[51,[30,8]],[[[1,\"      \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"  \"],[18,9,[[28,[37,3],null,[[\"wrapper\",\"details\",\"action\"],[[50,\"section/item-wrapper\",0,null,null],[50,\"section/item-details\",0,null,null],[50,\"section/item-action\",0,null,null]]]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"@title\",\"@titleStyles\",\"@qaClass\",\"@badge\",\"@subtitle\",\"@subtitleStyles\",\"@hideDivider\",\"&default\"],false,[\"if\",\"unless\",\"yield\",\"hash\",\"component\"]]",
    "moduleName": "settings/components/section.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});